var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgTruckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99665C0 3.58022 3.58022 0 7.99665 0C12.4131 0 15.9933 3.58022 15.9933 7.99665C15.9933 12.4131 12.4131 15.9933 7.99665 15.9933C3.58022 15.9933 0 12.4131 0 7.99665Z",
    fill: "#DBEAFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74093 10.2454V5.74768C8.74093 5.54886 8.66196 5.35819 8.52137 5.21761C8.38079 5.07703 8.19012 4.99805 7.99131 4.99805H4.99279C4.79398 4.99805 4.60331 5.07703 4.46273 5.21761C4.32214 5.35819 4.24316 5.54886 4.24316 5.74768V9.87063C4.24316 9.97004 4.28265 10.0654 4.35294 10.1357C4.42324 10.206 4.51857 10.2454 4.61798 10.2454H5.36761",
    stroke: "#155DFC",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1151 10.2454H6.86621",
    stroke: "#155DFC",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6143 10.2455H11.3639C11.4633 10.2455 11.5587 10.206 11.629 10.1357C11.6993 10.0654 11.7387 9.97005 11.7387 9.87064V8.50257C11.7386 8.41751 11.7095 8.33503 11.6563 8.26869L10.3519 6.63824C10.3169 6.59435 10.2724 6.55889 10.2218 6.5345C10.1712 6.5101 10.1158 6.49739 10.0596 6.49731H8.74023",
    stroke: "#155DFC",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86486 10.9951C10.2789 10.9951 10.6145 10.6595 10.6145 10.2455C10.6145 9.83147 10.2789 9.49585 9.86486 9.49585C9.45085 9.49585 9.11523 9.83147 9.11523 10.2455C9.11523 10.6595 9.45085 10.9951 9.86486 10.9951Z",
    stroke: "#155DFC",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11682 10.9951C6.53082 10.9951 6.86644 10.6595 6.86644 10.2455C6.86644 9.83147 6.53082 9.49585 6.11682 9.49585C5.70281 9.49585 5.36719 9.83147 5.36719 10.2455C5.36719 10.6595 5.70281 10.9951 6.11682 10.9951Z",
    stroke: "#155DFC",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_1041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.99554,
    height: 8.99554,
    fill: "white",
    transform: "translate(3.49316 3.49878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTruckIcon);
export default __webpack_public_path__ + "static/media/bg_truck_icon.9990d5ca277b31e97a847e956eea7510.svg";
export { ForwardRef as ReactComponent };